import { ReactNode } from "react";
import { SlideAction, ViewMode } from "./enums";

export interface ColumnData {
  id: string;
  title: string;
  mainComponent: ReactNode;
  headerComponent?: ReactNode;
  showHeader?: boolean;
}

// Context for passing click handlers and navigation to column content
export interface SlideLayoutContextType {
  // Data passed from previous column
  columnData?: Record<string, unknown>;
  currentColumnId: string;
  viewMode?: ViewMode;
  /*
   * Handler for item clicks within columns that trigger slide actions and navigation
   * @param slideAction - Action indicating the direction of the slide (NEXT or PREV)
   * @param nextColumn - ID of the next column to navigate to, empty string to maintain current column
   * @param itemData - Optional additional data to pass to the next column
   */
  onSlideColumnChange: (slideAction: SlideAction, nextColumn: string, itemData?: unknown) => void;
  // Function to navigate to a specific column by index
  navigateToColumn: (columnIndex: number) => void;
  // Data passed to next column
  setColumnData: (data: unknown) => void;
  /*
   * Handler for switching view modes (SINGLE or DUAL)
   * If mode is not provided, it toggles between modes
   */
  switchViewMode: (mode?: ViewMode) => void;
  /**
   * Set a custom title for a column by its id. Pass undefined to reset to default.
   * WARNING: Call this method only after the column has been rendered to avoid title reset on re-render.
   * @param columnId - ID of the column to set the title for
   * @param title - New title for the column
   */
  setColumnTitle: (columnId: string, title: string | undefined) => void;
}

export interface SlideLayoutProps {
  columns: ColumnData[];
  currentPairIndex?: number;
  onPairChange?: (pairIndex: number) => void;
  viewMode?: ViewMode;
  onViewModeChange?: (mode: ViewMode) => void;
  animationDuration?: number;
  onItemClick?: (slideAction: SlideAction, columnId: string, itemData?: unknown) => void;
}